import { render, staticRenderFns } from "./listSaidas.vue?vue&type=template&id=1d61cd7e&scoped=true"
import script from "./listSaidas.vue?vue&type=script&lang=js"
export * from "./listSaidas.vue?vue&type=script&lang=js"
import style0 from "./listSaidas.vue?vue&type=style&index=0&id=1d61cd7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d61cd7e",
  null
  
)

export default component.exports